import { createContext, useContext, type ReactNode } from 'react';

export function createEditorContext<T>(name: string) {
  const Context = createContext<T | undefined>(undefined);

  function Provider({ value, children }: { value: T; children: ReactNode }) {
    return <Context.Provider value={value}>{children}</Context.Provider>;
  }

  function useEditorContext(): T {
    const ctx = useContext(Context);
    if (!ctx) {
      throw new Error(`use${name}Context must be used within a ${name}Provider`);
    }
    return ctx;
  }

  return { Provider, useEditorContext };
}
